{
  "validation.required": "{{label}} er et obligatorisk felt",
  "validation.minLength": "{{label}} skal være mindst {{min}} tegn lang",
  "validation.maxLength": "{{label}} må ikke være længere end {{max}} tegn",
  "validation.contentTypeAlphanumeric": "{{label}} skal være alfanumerisk",
  "validation.contentTypeDate": "{{label}} skal være en dato",
  "validation.contentTypeDateBefore": "{{label}} skal være en dato før {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} skal være en dato efter {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} skal være en dato og et klokkeslæt",
  "validation.contentTypeDatetimeBefore": "{{label}} skal være en dato før {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} skal være en dato efter {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} skal være en e-mail",
  "validation.contentTypeInteger": "{{label}} skal være et tal",
  "validation.contentTypeNumber": "{{label}} skal være et tal",
  "validation.contentTypeRegex": "{{label}} har det forkerte format",
  "validation.contentTypeText": "{{label}} skal være en tekst",
  "validation.contentTypeTime": "{{label}} skal være et tidspunkt",
  "validation.contentTypeUrl": "{{label}} skal være en webadresse",
  "select-element.default-option": "Vælg…",
  "button-element.network-required":"Du er i øjeblikket offline. Opret en netværksforbindelse for at fortsætte."
}